document.addEventListener("DOMContentLoaded", function(e) {

	document.addEventListener('click', function (event) {
		if (!event.target.matches('.extras-read-more')) return;

		event.preventDefault();
		toggle_extras_modal(true, event.target.dataset.content);
	});

	document.addEventListener('click', function (event) {
		if (!event.target.matches('#close_extras')) return;

		event.preventDefault();
		toggle_extras_modal(false);
	});

	function toggle_extras_modal(open = true, content = false) {
		let popup = document.getElementById('extras-popup');
		let content_div = document.querySelector('#extras-popup .content');

		console.log(content_div);

		if(popup) {
			if(open) {
				if(content_div && content) {
					content_div.innerHTML = (content.replace(/(?:\r\n|\r|\n)/g, '<br>'));
				}

				popup.classList.add('active');
			} else {
				popup.classList.remove('active');

				setTimeout(function() {
					if(content_div) {
						content_div.innerHTML = '';
					}
				}, 300);
			}
		}
	}

});